import { Validator } from 'vee-validate';

const isOnlyDashAndLowercase = (value) => {
  const regex = /^[a-zæøå0-9-]*$/g; 
  const result = value.match(regex);
  return result !== null;
};

// The messages getter may also accept a third parameter that includes the data we returned earlier.
Validator.extend('isOnlyDashAndLowercase', {
  validate: isOnlyDashAndLowercase,
  getMessage: (field, params, data) => {
    return 'Wrong format, use all lower case and dash';
  },
});
